/**
 * KODIAK SPORTS — PHOTO GALLERY
 * File: assets/kodiak-gallery.js
 * Handles: tab switching, lightbox, keyboard nav
 */
(function () {
  'use strict';

  var currentImages = [];
  var currentIndex  = 0;

  /* ── TABS ───────────────────────────────────────────────── */
  function initTabs() {
    var tabs     = document.querySelectorAll('.g-tab');
    var sections = document.querySelectorAll('.g-section');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.dataset.tab;

        tabs.forEach(function (t) { t.classList.remove('active'); });
        sections.forEach(function (s) { s.classList.remove('active'); });

        tab.classList.add('active');
        var section = document.getElementById('tab-' + target);
        if (section) section.classList.add('active');

        // Rebuild image array for lightbox
        buildImageArray(section);
      });
    });

    // Build initial array from first active section
    var firstSection = document.querySelector('.g-section.active');
    if (firstSection) buildImageArray(firstSection);
  }

  /* ── LIGHTBOX ───────────────────────────────────────────── */
  function buildImageArray(section) {
    currentImages = [];
    if (!section) return;
    var items = section.querySelectorAll('.g-item');
    items.forEach(function (item) {
      currentImages.push({
        src:     item.dataset.src,
        caption: item.dataset.caption || ''
      });
    });
  }

  function openLightbox(index) {
    currentIndex = index;
    var lb      = document.getElementById('g-lightbox');
    var img     = document.getElementById('lb-img');
    var caption = document.getElementById('lb-caption');
    if (!lb || !img) return;

    img.src       = currentImages[index].src;
    img.alt       = currentImages[index].caption;
    caption.textContent = currentImages[index].caption;
    lb.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    var lb = document.getElementById('g-lightbox');
    if (lb) lb.classList.remove('open');
    document.body.style.overflow = '';
  }

  function showPrev() {
    currentIndex = (currentIndex - 1 + currentImages.length) % currentImages.length;
    var img     = document.getElementById('lb-img');
    var caption = document.getElementById('lb-caption');
    if (img) { img.src = currentImages[currentIndex].src; img.alt = currentImages[currentIndex].caption; }
    if (caption) caption.textContent = currentImages[currentIndex].caption;
  }

  function showNext() {
    currentIndex = (currentIndex + 1) % currentImages.length;
    var img     = document.getElementById('lb-img');
    var caption = document.getElementById('lb-caption');
    if (img) { img.src = currentImages[currentIndex].src; img.alt = currentImages[currentIndex].caption; }
    if (caption) caption.textContent = currentImages[currentIndex].caption;
  }

  function initLightbox() {
    // Delegate click on all grid items
    document.addEventListener('click', function (e) {
      var item = e.target.closest('.g-item');
      if (!item) return;

      // Find index in current active section
      var section = document.querySelector('.g-section.active');
      if (!section) return;
      buildImageArray(section);

      var items = Array.from(section.querySelectorAll('.g-item'));
      var index = items.indexOf(item);
      if (index > -1) openLightbox(index);
    });

    var closeBtn = document.getElementById('lb-close');
    var prevBtn  = document.getElementById('lb-prev');
    var nextBtn  = document.getElementById('lb-next');
    var lb       = document.getElementById('g-lightbox');

    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    if (prevBtn)  prevBtn.addEventListener('click',  showPrev);
    if (nextBtn)  nextBtn.addEventListener('click',  showNext);

    // Close on backdrop click
    if (lb) {
      lb.addEventListener('click', function (e) {
        if (e.target === lb) closeLightbox();
      });
    }

    // Keyboard nav
    document.addEventListener('keydown', function (e) {
      var lb = document.getElementById('g-lightbox');
      if (!lb || !lb.classList.contains('open')) return;
      if (e.key === 'Escape')      closeLightbox();
      if (e.key === 'ArrowLeft')   showPrev();
      if (e.key === 'ArrowRight')  showNext();
    });
  }

  /* ── SCROLL REVEAL ──────────────────────────────────────── */
  function initReveal() {
    var items = document.querySelectorAll('.g-item');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });

    items.forEach(function (item, i) {
      item.style.opacity    = '0';
      item.style.transform  = 'translateY(20px)';
      item.style.transition = 'opacity .5s ease ' + (i % 8 * 0.06) + 's, transform .5s ease ' + (i % 8 * 0.06) + 's';
      observer.observe(item);
    });
  }

  /* ── INIT ───────────────────────────────────────────────── */
  function init() {
    initTabs();
    initLightbox();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
